import React, { useState } from 'react';
import './DislikeReasonModal.css';

export interface DislikeReason {
    id: string;
    label: string;
    icon: string;
}

const DISLIKE_REASONS: DislikeReason[] = [
    { id: 'not_like_me', label: 'Bana benzemiyor', icon: '🪞' },
    { id: 'wrong_clothes', label: 'Kıyafet yanlış görünüyor', icon: '👕' },
    { id: 'physical_errors', label: 'Fiziksel hatalar var', icon: '⚠️' },
    { id: 'low_quality', label: 'Video kalitesi düşük', icon: '📹' },
    { id: 'other', label: 'Diğer', icon: '💭' }
];

interface DislikeReasonModalProps {
    isOpen: boolean;
    onClose: () => void;
    onReasonSelect: (reason: string) => void;
    isLoading?: boolean;
}

export const DislikeReasonModal: React.FC<DislikeReasonModalProps> = ({
    isOpen,
    onClose,
    onReasonSelect,
    isLoading = false
}) => {
    const [selectedReason, setSelectedReason] = useState<string | null>(null);

    if (!isOpen) return null;

    const handleReasonClick = (reasonId: string) => {
        setSelectedReason(reasonId);
    };

    const handleSubmit = () => {
        if (selectedReason) {
            onReasonSelect(selectedReason);
            setSelectedReason(null);
        }
    };

    const handleOverlayClick = (e: React.MouseEvent) => {
        if (e.target === e.currentTarget && !isLoading) {
            onClose();
        }
    };

    return (
        <div className="dislike-modal-overlay" onClick={handleOverlayClick}>
            <div className="dislike-modal">
                <div className="dislike-modal__header">
                    <h3 className="dislike-modal__title">Ne oldu?</h3>
                    <p className="dislike-modal__subtitle">
                        Geri bildiriminiz video kalitesini artırmamıza yardımcı olur
                    </p>
                    {!isLoading && (
                        <button 
                            className="dislike-modal__close" 
                            onClick={onClose}
                            aria-label="Kapat"
                        >
                            ✕
                        </button>
                    )}
                </div>

                <div className="dislike-modal__reasons">
                    {DISLIKE_REASONS.map((reason) => (
                        <button
                            key={reason.id}
                            className={`dislike-reason ${selectedReason === reason.id ? 'selected' : ''}`}
                            onClick={() => handleReasonClick(reason.id)}
                            disabled={isLoading}
                        >
                            <span className="dislike-reason__icon">{reason.icon}</span>
                            <span className="dislike-reason__label">{reason.label}</span>
                            {selectedReason === reason.id && (
                                <span className="dislike-reason__check">✓</span>
                            )}
                        </button>
                    ))}
                </div>

                <div className="dislike-modal__actions">
                    <button
                        className="dislike-modal__submit"
                        onClick={handleSubmit}
                        disabled={!selectedReason || isLoading}
                    >
                        {isLoading ? (
                            <>
                                <span className="dislike-modal__spinner" />
                                Yeniden oluşturuluyor...
                            </>
                        ) : (
                            'Yeniden Oluştur'
                        )}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default DislikeReasonModal;
